module.exports = __webpack_public_path__ + "static/1 (2)-c09632a51999b1febee94ba4fd97d17b.jpg";